import { useContext } from "react";
import { homeContext } from "pages/HomeContext";
import { imgPath } from "methods/img";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectFade, Autoplay, Navigation } from "swiper/modules";
import { Box } from "@mui/material";
import "./Slider.css";

function Slider() {
  const { homeData } = useContext(homeContext);
  const sliders = homeData?.sliders || [];

  return (
    <>
      {sliders.length > 0 ? (
        <Box>
          <Swiper
            className="Swiper_test"
            slidesPerView={1}
            spaceBetween={50}
            speed={900}
          modules={[EffectFade, Autoplay, Navigation]}
            allowSlideNext={true}
            allowSlidePrev={true}
            autoplay={{ delay: 2000, disableOnInteraction: true }}
            effect="fade"
            loop={sliders.length > 1}
            navigation={true}
            fadeEffect={{ crossFade: true }}
          >
            {sliders.map((image) => (
              <SwiperSlide key={image.id}>
                <img
                  src={imgPath(image.image)}
                  alt="card media image"
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </Box>
      ) : (
        "لا يوجد صور للعرض"
      )}
    </>
  );
}

export default Slider;